import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuthStore, type ActionResult } from '../stores/platformAuthStore';
import { formStyles as styles } from '../components/formStyles';

export function VerifyEmail() {
  return (
    <LinkLanding
      title="Confirm your email"
      run={(token) => useAuthStore.getState().verifyEmail(token)}
      done="Your email is confirmed. You can create games now."
    />
  );
}

export function ConfirmEmailChange() {
  return (
    <LinkLanding
      title="Confirm your new email"
      run={(token) => useAuthStore.getState().confirmEmailChange(token)}
      done="Your account now uses this email address."
    />
  );
}

function LinkLanding({
  title,
  run,
  done,
}: {
  title: string;
  run: (token: string) => Promise<ActionResult>;
  done: string;
}) {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [result, setResult] = useState<ActionResult | null>(null);
  const loggedIn = useAuthStore((s) => !!s.token);
  // Each link works once; StrictMode's double effect must not spend it twice.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!token) {
      setResult({ ok: false, error: 'This link is missing its token' });
      return;
    }
    run(token).then(setResult);
  }, [token, run]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{title}</h2>
        {!result && <p style={styles.text}>Checking your link...</p>}
        {result?.ok && <div style={styles.success}>{done}</div>}
        {result && !result.ok && <div style={styles.error}>{result.error}</div>}
        <div style={styles.footer}>
          <Link to={loggedIn ? '/dashboard' : '/login'} style={styles.link}>
            {loggedIn ? 'Go to your dashboard' : 'Log in'}
          </Link>
        </div>
      </div>
    </div>
  );
}
